import React from 'react'
import agent from '../agent'
import TokenList from './widgets/TokenList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import {
    TOKEN_ADMIN_LIST_PAGE_LOADED,
    TOKEN_ADMIN_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import TokenAdminList from './widgets/TokenAdminList';
import role from '../util/role'
const mapStateToProps = state => ({
    ...state.token,
    currentUser: state.common.currentUser,
    appName: state.common.appName,
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) => {
        dispatch({ type: TOKEN_ADMIN_LIST_PAGE_LOADED, payload })
    },
    onUnload: () =>
        dispatch({ type: TOKEN_ADMIN_LIST_PAGE_UNLOADED }),
});

class TokenAdmins extends React.Component {
    constructor() {
        super();
    }
    componentWillMount() {
        const payload = agent.Tokens.getTokenAdmins()
        this.props.onLoad(payload);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        return (
            <div class='pane'>
                <h1>Token Owners</h1>
                <TokenAdminList data={this.props.users} loading={this.props.loading} />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenAdmins);



// WEBPACK FOOTER //
// ./src/components/TokenAdmins.js